export default function Clips() {
  return <div>Clips</div>;
}
